import React from "react";
import {
  useFormatDateInterval,
  useSecondsToTime,
} from "../hooks/useFormatDateInterval";
import { useNumber } from "../hooks/useNumerFormatter";

import { useChartContext } from "../chart/ShortsworksChart/ChartProvider";

type ChartTooltipProps = {
  active: boolean;
  value: number;
  name: string;
  label: string;
  dataKey: string;
  payload: Record<string, any>;
};

export function ChartTooltip({ active, label, payload }: ChartTooltipProps) {
  const { format, interval } = useChartContext();
  const formatDate = useFormatDateInterval(interval);
  const time = useSecondsToTime();
  const number = useNumber();
  if (!active || !payload) {
    return null;
  }

  if (!payload.length) {
    return null;
  }

  const getFormattedValue = (value: number) => {
    switch (format) {
      case "number":
        return number.format(value);
      case "time":
        return time(Math.round(value / 1000));
      case "filesize":
        return number.shortWithUnit(value, "GB");
      default:
        return value;
    }
  };

  return (
    <div
      className="flex min-w-[180px] flex-col gap-2 rounded-xl border bg-card p-3 text-sm shadow-xl"
      style={{
        display: "flex",
        minHeight: "auto",
        flexDirection: "column",
        gap: "0.5rem",
        borderRadius: "0.5rem",
        border: "1px solid #E2E8F0",
        backgroundColor: "#FFF",
        padding: "0.75rem",
        fontSize: "0.875rem",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        className="flex justify-between gap-8"
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "2rem",
        }}
      >
        <div>{formatDate(new Date(label))}</div>
      </div>
      <div
        className="flex gap-2"
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        <div
          className="w-[3px] rounded-full"
          style={{
            background: "#BC3BE9",
            width: "3px",
            borderRadius: "2px",
          }}
        />
        <div
          className="flex flex-1 flex-col"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <div
            className="flex justify-between gap-8"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "2rem",
            }}
          >
            <div>{getFormattedValue(payload[0].value)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
